/* eslint-disable @nx/enforce-module-boundaries */
import {
  Component, EventEmitter, Input, Output
} from '@angular/core';
import { IrisButtonTypeAttributeOptions, IrisButtonTarget } from '../../../shared/src/index';

export enum IrisButtonTypes {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  DANGER = 'danger'
}

export enum IrisButtonIconPositions {
  LEFT = 'left',
  RIGHT = 'right'
}

@Component({
  selector: 'iris-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})

export class IrisButtonComponent {
  private irisButtonTypes = IrisButtonTypes;
  @Input() type: IrisButtonTypes = this.irisButtonTypes.PRIMARY;
  @Input() typeAttribute: IrisButtonTypeAttributeOptions = IrisButtonTypeAttributeOptions.SUBMIT;
  @Input() disabled: boolean | undefined;
  @Input() linkHref: string | undefined;
  @Input() iconPosition: IrisButtonIconPositions | undefined;
  @Input() ksDocsOnlyButtonText: string | undefined;
  @Input() target: IrisButtonTarget | undefined;
  @Output() click = new EventEmitter();

  buttonClasses!: string;
  irisButtonIconPosition = IrisButtonIconPositions;

  onClick(event: Event): void {
    event.stopImmediatePropagation();
    if (!this.disabled) {
      this.click.emit(event);
    }
  }

  ngOnInit(): void {
    this.buttonClasses = `iris-button iris-button--${this.type}`;
  }
}
